export const crmConstant = {
  email_success: "Email sent Successfully",
  sendEmail: "Send Email",
  call: "Call",
  contact: "Contact",
  contacts: "Contacts",
  lead: "Lead",
  task: "Task",
  password: "Password",
  property: "Property",
  save: "Save",
  startDate: "Start Date",
  endDate: "End Date",
  properties: "Products",
  owner: "Owner",
  subject: "Subject",
  asignToLead: "Assign To Lead",
  leadErrorMsg: "This field is required",
  priority: "Priority",
  assignTo: "Assign To",
  priorityList: [
    { label: "Not Defined", value: "not_defined" }, // New option added
    { label: "Low", value: "low" },
    { label: "Medium", value: "medium" },
    { label: "High", value: "high" },
    { label: "Highest", value: "highest" },
  ],
  selectPriority: "Select",
  meeeting: "Meeting",
  agenda: "Agenda",
  related: "Related To",
  editMeeting: "Edit Meeting",
  attendees: "Attendees",
  preferredAssignee: `Choose Preferred Attendees From`,
  participants: "Choose Participants From",
  meetingSuccess: "Meeting added successfully",
  callSuccess: "Call created successfully",
  selectedTO: "Select Related To",
  minutes: "minutes",
  editCall: "Edit Call",
  view: "View",
  assignedTo: "Assigned To",
  deals: "Deals",
  accounts: "Accounts",
  close: "Close",
  account: "Account",
  callLogs: "Call Log",
  selectAccount: "Select Account",
  fileExtention: [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".pdf"],
  taskInfo: "Task Info",
  recipient: "Recipient",
  senderName: "Sender Name",
  callDuration: "Call Duration",
  createdBy: "Created By",
  callNotes: "Call Notes",
  dateAndTime: "Date & Time",
  createdDate: "Created On",
  meetingDate: "Meeting Date",
  location: "Location",
  notes: "Notes",
  createCallLog: "Create Call Log",
  editCallLog: "Edit Call Log",
  user: "User",
  edit: "Edit",
  delete: "Delete",
  emailId: "Email Id",
  firstName: "First Name",
  lastName: "Last Name",
  role: "Role",
  actions: "Actions",
  completed: "Completed",
  todo: "To Do",
  onHold: "On Hold",
  inProgress: "In Progress",
  pending: "Pending",
  taskInformation: "Task Information",
  createTask: "Create Task",
  inBound: "Inbound",
  outBound: "Outbound",
  cancel: "Cancel",
  back: "Back",
  action: "Action",
  COLUMNS_DATA_HEADERS: {
    SENDER: "sender",
    RECIPIENT: "recipient",
    TIMESTAMP: "time stamp",
    CREATED_AT: "Created At",
  },
  PROPERTY_HEADERS: {
    PROPERTY_TYPE: "Product Type",
    PROPERTY_ADDRESS: "Product Address",
    LISTING_PRICE: "Listing Price",
    SQUARE_FOOTAGE: "Square Footage",
    YEAR_BUILT: "Year Built",
  },
  PROPERTY_ACCESSORS: {
    PROPERTY_TYPE: "propertyType",
    PROPERTY_ADDRESS: "propertyAddress",
    LISTING_PRICE: "listingPrice",
    SQUARE_FOOTAGE: "squareFootage",
    YEAR_BUILT: "yearBuilt",
  },
  TEXT_COLUMNS_HEADERS: {
    SENDER: "sender",
    RECIPIENT: "recipient",
    TIMESTAMP: "time stamp",
    CREATED: "Created",
  },
  MEETING_HEADERS: {
    AGENDA: "agenda",
    DATE_TIME: "Date Time",
    TIMESTAMP: "times Stamp",
    CREATED_BY: "create By",
    LOCATION: "Location",
    RELATED: "Related To",
  },
  TASK_HEADERS: {
    TITLE: "Title",
    CATEGORY: "Category",
    ASSIGN_TO: "Assign To",
    START_DATE: "Start Date",
    END_DATE: "End Date",
  },
  taskName: "Task Name",
  dueDate: "Due Date",
  status: "Status",
  callSubject: "Call Subject",
  callType: "Call Type",
  assignToUser: "Assign To User",
  meetingName: "Meeting Name",
  toDo: "To Do",
  fileName: "File Name",
  attachedBy: "Attached by",
  dateAdded: "Date Added",
  size: "Size",
  sender: "Sender",
  createdAt: "Created At",
  timeStamp: "Time stamp",
  attachment: "Attachments",
  attach: "Attach",
  scheduled: "Scheduled",
  cancelled: "Cancelled",
  description: "Description",
  meetingInformation: "Meeting Information",
  createMeeting: "Create Meeting",
  enterSubject: "Enter Subject",
  select: "Select",
  participant: "Participant",
  title: "Title",
  callInformation: "Call Information",
  createLead: "Create Lead",
  leadInformation: "Lead Information",
  contactInformation: "Contact Information",
  createContact: "Create Contact",
  taskAddedSuccessFully: "Task Added Successfully",
  someThingWentWrong: "Something went wrong",
  leadAddedSuccessfully: "Lead Added Successfully",
  contactAddedSuccessfully: "Contact Added Successfully",
  propertyAddedSuccessFully: "Product Added Successfully",
  createProperty: "Create Product",
  propertyInformation: "Product Information",
  relatedValue: "related",
  maxFileSize: "File size should not exceed 5 MB.",
  contactNo: "Contact No",
  discard: "Discard",
  send: "Send",
  recipientContact: "Recipient (Contact)",
  recipientLead: "Recipient (Lead)",
  emails: "Emails",
  ccRecipientContact: "CC Recipient (Contact)",
  ccRecipientLead: "CC Recipient (Lead)",
  ccEmails: "CC Emails",
  emailBody: "Email Body",
  emailInformation: "Email Information",
  createEmail: "Create Email",
  category: "Category",
  virtualTourVideos: "Product Videos",
  statusUpdated: "Status updated successfully",
  phoneCallUpdatedSuccess: "Phone call updated successfully!",
  phoneCall: "Phone Call",
  convert: "Convert Lead",
  createNewAcc: "Create New Account",
  createNewContact: "Create New Contact",
  createNewOpportunity: "Create a new Deal for this Account",
  amountMustBeNumber: "Amount must be a number",
  dealNameRequired: "Deal Name is required",
  closingDateRequired: "Closing Date is required",
  stageRequired: "Stage is required",
  amount: "Amount",
  dealName: "Deal Name",
  closingDate: "Closing Date",
  calls: "Calls",
  meetings: "Meetings",
  photos: "Photos",
  videos: "Videos",
  documents: "Documents",
  plans: "Plans",
  noMeetingFound: "No meetings found",
  roleDeleteSuccess: "Role deleted successfully",
  roleRequired: "Role Name is required",
  descriptionRequired: "Description is required",
  closeDate: "Closing Date",
  accountName: "Account Name",
  industry: "Industry",
  annualRevenue: "Annual Revenue",
  accountStatus: "Account Status",
  stage: "Stage",
  leadConvertedSuccessfully: "Lead Converted Successfully",
  propertyOfInterest: "Product of Interest",
  leadComponentName: "lead",
  contactComponentName: "contact",
  attachmentDeletedSuccessfully: "Attachment deleted successfully",
  contactName: "Contact Name",
  companyName: "Company Name",
  emailAddress: "Email Address",
  jobTitle: "Job Title",
  selectParticipant: "Select Participant",
  attachments: "Attachments",
  emailTitle: "Email",
  unauthorizedError: "You are not authorized to delete this note",
  viewUpdateSuccessfully: "View updated successfully",
  failedToUpdateViewPreference: "Failed to update view",
  converted: "Converted",
  deletedSuccessfully: "deleted successfully!",
  accountSigular: "Account",
  dealSingular: "Deal",
  workflowRule: "WorkflowRule",
  workflowTitle: "Workflow Rules"
};
